import React, { useState } from 'react'
import logo from '../images/logo_bw.png'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router-dom'
import { CiMenuFries } from "react-icons/ci";
const Nav = () => {

  const [open ,setOpen] = useState()
    
    const location  = useLocation()
  return (
    <div>
        <nav className="hidden md:flex px-20 py-3 items-center justify-between sticky z-20 top-0 w-full bg-white backdrop-filter backdrop-blur-2xl bg-opacity-80">
                <img src={logo} className="h-20"></img>
                <div className="flex items-center space-x-8">
                    <Link to="/">
                    <p className={location.pathname=="/"?"text-blue-500":""}>Home</p>
                    </Link>
                    <Link to="/aboutus">
                    <p className={location.pathname=="/aboutus"?"text-blue-500":""}>About us</p>
                    </Link>
                    <Link to="/howitworks">
                    <p className={location.pathname=="/howitworks"?"text-blue-500":""}>How it works</p>
                    </Link>
                    <Link to="/request">
                    <p className={location.pathname=="/request"?"text-blue-500":""}>Request a demo</p>
                    </Link>
                    <a href="https://interviewguru.co/blog/">
                    <p>Blogs</p>
                    </a>
                    {/* <Link to="/support">
                    <p className={location.pathname=="/support"?"text-blue-500":""}>Support</p>
                    </Link> */}
                    <Link to="/">
                    <button className=" border-[#148EFF] text-[#148EFF] border rounded-lg p-2 px-4">Login</button>
                    </Link>
                </div>
                
            </nav>

            <div className='md:hidden  w-full'>
            <nav className="flex px-4 bg-white backdrop-filter items-center justify-between backdrop-blur-lg py-3">
              <img src={logo} className="h-16"></img>
              <button onClick={()=>{setOpen(!open)}}>
              <CiMenuFries classNamme="text-4xl"></CiMenuFries>
              </button>
            </nav>
            {
             open && 
            <div className="absolute  h-full backdrop-filter backdrop-blur-lg bg-white z-20 right-0 w-2/3">
            <div className="flex flex-col mt-4 items-center space-y-8">
                    <Link to="/">
                    <p className={location.pathname=="/"?"text-blue-500":""}>Home</p>
                    </Link>
                    <Link to="/aboutus">
                    <p className={location.pathname=="/aboutus"?"text-blue-500":""}>About us</p>
                    </Link>
                    <Link to="/howitworks">
                    <p className={location.pathname=="/howitworks"?"text-blue-500":""}>How it works</p>
                    </Link>
                    <Link to="/request">
                    <p className={location.pathname=="/request"?"text-blue-500":""}>Request a demo</p>
                    </Link>
                    <a href="https://interviewguru.co/blog/">
                    <p>Blogs</p>
                    </a>
                    {/* <Link to="/support">
                    <p className={location.pathname=="/support"?"text-blue-500":""}>Support</p>
                    </Link> */}
                </div>
            </div>
            }
            </div>
    </div>
  )
}

export default Nav